import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const WorkerlatestlocationAddPage = (props) => {
		const app = useApp();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		latitude: yup.number().nullable().label($t('latitude')),
		longitude: yup.number().nullable().label($t('longitude')),
		userid: yup.string().required().label($t('userid')),
		accuracy: yup.number().nullable().label($t('accuracy')),
		battery_level: yup.number().nullable().label($t('batteryLevel'))
	});
	
	//form default values
	const formDefaultValues = {
		latitude: '', 
		longitude: '', 
		userid: '', 
		accuracy: '', 
		battery_level: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/workerlatestlocation`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="WorkerlatestlocationAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewWorkerLatestLocation')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('latitude')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="latitude"  onChange={formik.handleChange}  value={formik.values.latitude}   label={$t('latitude')} type="number" placeholder={$t('enterLatitude')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.latitude)} />
                                                <ErrorMessage name="latitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('longitude')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="longitude"  onChange={formik.handleChange}  value={formik.values.longitude}   label={$t('longitude')} type="number" placeholder={$t('enterLongitude')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.longitude)} />
                                                <ErrorMessage name="longitude" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('userid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/userid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="userid"     optionLabel="label" optionValue="value" value={formik.values.userid} onChange={formik.handleChange} options={response} label={$t('userid')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.userid)}   />
                                                    <ErrorMessage name="userid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accuracy')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accuracy"  onChange={formik.handleChange}  value={formik.values.accuracy}   label={$t('accuracy')} type="number" placeholder={$t('enterAccuracy')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.accuracy)} />
                                                <ErrorMessage name="accuracy" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('batteryLevel')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="battery_level"  onChange={formik.handleChange}  value={formik.values.battery_level}   label={$t('batteryLevel')} type="number" placeholder={$t('enterBatteryLevel')}  min={0}  step="any"    className={inputClassName(formik?.errors?.battery_level)} />
                                                <ErrorMessage name="battery_level" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
WorkerlatestlocationAddPage.defaultProps = {
	primaryKey: 'userid',
	pageName: 'workerlatestlocation',
	apiPath: 'workerlatestlocation/add',
	routeName: 'workerlatestlocationadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default WorkerlatestlocationAddPage;
